module.exports = __webpack_public_path__ + "static/sponsor-04-e88b765088663132f630be94654a4d29.png";